import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {mapCloudItemResponseInstance} from '@toolify/client/src/modules/api/singletons/mapCloudItemResponseInstance'
import {
  INotificationPayloadMapperStrategy,
} from '@toolify/client/src/modules/api/notificationPayloadMappers/types/INotificationPayloadMapperStrategy'

type T = NotificationType.CloudItemCreated

export const CloudItemCreatedNotificationPayloadMapperStrategy: INotificationPayloadMapperStrategy<T> = {
  mapPayload(payload) {
    return {
      ...payload,
      cloudItem: mapCloudItemResponseInstance(payload.cloudItem),
    }
  },
}
